//Getting data from API

export const GET_DATA_REQUEST_ONE = "GET_DATA_REQUEST_ONE";
export const GET_DATA_FAILURE_ONE = "GET_DATA_FAILURE_ONE";

export const GET_DATA_REQUEST_TWO = "GET_DATA_REQUEST_TWO";
export const GET_DATA_FAILURE_TWO = "GET_DATA_FAILURE_TWO";

export const GET_DATA_REQUEST_THREE = "GET_DATA_REQUEST_THREE";
export const GET_DATA_FAILURE_THREE = "GET_DATA_FAILURE_THREE";

export const GET_DATA_REQUEST_FOUR = "GET_DATA_REQUEST_FOUR";
export const GET_DATA_FAILURE_FOUR = "GET_DATA_FAILURE_FOUR";

export const GET_DATA_REQUEST_FIVE = "GET_DATA_REQUEST_FIVE";
export const GET_DATA_FAILURE_FIVE = "GET_DATA_FAILURE_FIVE";

export const GET_DATA_REQUEST_SIX = "GET_DATA_REQUEST_SIX";
export const GET_DATA_FAILURE_SIX = "GET_DATA_FAILURE_SIX";

export const GET_DATA_REQUEST_SEVEN = "GET_DATA_REQUEST_SEVEN";
export const GET_DATA_FAILURE_SEVEN = "GET_DATA_FAILURE_SEVEN";

export const GET_DATA_REQUEST_EIGHT = "GET_DATA_REQUEST_EIGHT";
export const GET_DATA_FAILURE_EIGHT = "GET_DATA_FAILURE_EIGHT";

export const GET_DATA_SUCCESS_ONE = "GET_DATA_SUCCESS_ONE";
export const GET_DATA_SUCCESS_TWO = "GET_DATA_SUCCESS_TWO";
export const GET_DATA_SUCCESS_THREE = "GET_DATA_SUCCESS_THREE";
export const GET_DATA_SUCCESS_FOUR = "GET_DATA_SUCCESS_FOUR";
export const GET_DATA_SUCCESS_FIVE = "GET_DATA_SUCCESS_FIVE";
export const GET_DATA_SUCCESS_SIX = "GET_DATA_SUCCESS_SIX";
export const GET_DATA_SUCCESS_SEVEN = "GET_DATA_SUCCESS_SEVEN";
export const GET_DATA_SUCCESS_EIGHT = "GET_DATA_SUCCESS_EIGHT";
